"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const rollbar_1 = __importDefault(require("../utils/development/rollbar"));
const segment_1 = __importDefault(require("../utils/development/segment"));
const sentry_1 = __importDefault(require("../utils/development/sentry"));
function useAsyncTask(callback, deps) {
    const [{ loading, args }, setLoading] = (0, react_1.useState)({
        loading: false,
        args: null,
    });
    (0, react_1.useEffect)(() => {
        if (!loading) {
            return;
        }
        if (args === null) {
            return;
        }
        let cancelled = false;
        Promise.resolve()
            .then(() => callback(...args))
            .then(() => {
            if (cancelled) {
                return;
            }
            setLoading({ loading: false, args: null });
        })
            .catch((err) => {
            console.error(err);
            (0, rollbar_1.default)((rollbar) => rollbar.error(err));
            (0, sentry_1.default)((sentry) => sentry.captureException(err));
            (0, segment_1.default)((analytics) => analytics.track('error', {
                ...err,
                message: err.message,
                stack: err.stack,
            }));
            if (cancelled) {
                return;
            }
            setLoading({ loading: false, args: null });
        });
        return () => {
            cancelled = true;
        };
    }, [loading]);
    const callTask = (0, react_1.useCallback)((...args) => {
        setLoading({ loading: true, args });
    }, [loading, args, ...deps]);
    return [loading, callTask];
}
exports.default = useAsyncTask;
